import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CreamsSalesDashVM, SalesByYearVM, SalesByYearMonthVM, SalesByMonthVM, SalesByDayOfWeekVM, SalesByDateVM, 
  GetSalesImportQueryResponse, GetSalesImportsQueryResponse, CreateSalesImportCommand } from '../../interfaces/interfaces';
import { AuthService } from 'src/app/services/auth.service';
import { MaintainWatchComponent } from '../maintain-watch/maintain-watch.component';
import { map, Observable, take } from 'rxjs';
import { AddEvent, DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { State, process, CompositeFilterDescriptor, filterBy, AggregateDescriptor, GroupDescriptor, GroupResult, aggregateBy } from "@progress/kendo-data-query";
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/user.service';
import { CreamsSalesDashClass } from '../creams-dash/creamsSalesDash';
import { groupBy } from "@progress/kendo-data-query";

interface Model {
  product: string;
  sales: number;
}

@Component({
  selector: 'sdc-mh-dash',
  templateUrl: './mh-dash.component.html',
  styleUrls: ['./mh-dash.component.scss']
})
export class MHDashComponent implements OnInit {

  watchForm: UntypedFormGroup;
  userName: string;
  role: string;
  isLoading = false;
  canEdit = false;
  chosenWatch: GetSalesImportsQueryResponse;
  watches = [];
  watchTableDataSource = new MatTableDataSource<GetSalesImportsQueryResponse>();
  @ViewChild('watchTablePaginator') watchTablePaginator: MatPaginator;
  watchDisplayColumns: string[] = [
    'name', 'store', 'description', 'dateModified', 'imported', 'importDate', 'actions'];
  watchDisplayHeaders: Array<any> = [
    { key: 'name', header: 'File' },
    { key: 'store', header: 'Store' },
    { key: 'description', header: 'Description' },
    { key: 'dateModified', header: 'Upload Date' },
    { key: 'imported', header: 'Imported' },
    { key: 'importDate', header: 'Import Date' },
  ];



  //public gridData: SalesByYearVm[]; // | GroupResult[]; // Observable<any>;
  
  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };
  public newDataItem: CreateSalesImportCommand;
  public editDataItem: GetSalesImportQueryResponse;
  public isNew: boolean;
  public watch: GetSalesImportQueryResponse;
  public sales: CreamsSalesDashVM;

  

  constructor(
    private authService: AuthService,
  ) { }

  public gridState: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  salesByYearVm: SalesByYearVM[] = [];
  salesByYearMonthVm: SalesByYearMonthVM[] = [];
  salesByMonthVm: SalesByMonthVM[] = [];
  salesByDayOfWeekVm: SalesByDayOfWeekVM[] = [];
  currentYearVm: SalesByYearVM[] = [];
  currentMonthVm: SalesByYearMonthVM[] = [];
  currentDateVm: SalesByDateVM[] = [];
  //public gridData: SalesByYearVm[];
  public gridData: any = process(this.salesByYearVm, this.gridState);
  public gridDataMonth: any = process(this.salesByMonthVm, this.gridState);
  public gridDataYearMonth: any = process(this.salesByYearMonthVm, this.gridState);
  public gridDataDayOfWeek: any = process(this.salesByDayOfWeekVm, this.gridState);

  public gridDataCurrentYear: any = process(this.currentYearVm, this.gridState);
  public gridDataCurrentMonth: any = process(this.currentMonthVm, this.gridState);
  public gridDataCurrentDay: any = process(this.currentDateVm, this.gridState);
  public aggregates: AggregateDescriptor[] = [
    { field: "totalSales", aggregate: "sum" },
    { field: "netSales", aggregate: "sum" },
    { field: "cashSales", aggregate: "sum" },
    { field: "cardSales", aggregate: "sum" },
    { field: "deliverySales", aggregate: "sum" },
    { field: "deliverooSales", aggregate: "sum" },
    { field: "justEatSales", aggregate: "sum" },
    { field: "uberEatsSales", aggregate: "sum" },
    { field: "multipleSales", aggregate: "sum" },
  ];

  public total: any = aggregateBy(this.gridData.data, this.aggregates);
  public totalMonth: any = aggregateBy(this.gridDataMonth.data, this.aggregates);
  public totalYearMonth: any = aggregateBy(this.gridDataYearMonth.data, this.aggregates);
  public totalDayOfWeek: any = aggregateBy(this.gridDataDayOfWeek.data, this.aggregates);

  public seriesData: Model[] = [
    {
      product: "Chai",
      sales: 200,
    },
    {
      product: "Others",
      sales: 250,
    },
  ];

  ngOnInit(): void {
    this.canEdit = true;
    this.userName = localStorage.getItem('currentUserName');
    this.intialiseData();
  }

  intialiseData(): void {

    this.loadCreamsSales();
    
    /*this.authService.apiAuthCreamsSalesDashGet().pipe(take(1)).subscribe({
      next: (response) => {
        //alert("Test");()
        this.sales = response.map((data) => ({
          year: data.year,
          month: data.month,
          date: data.date,
          totalSales: data.totalSales,
          netSales: data.netSales,
          cardSales: data.cardSales,
          cashSales: data.cashSales,
          deliverySales: data.deliverySales,
          deliverooSales: data.deliverooSales,
          justEatSales: data.justEatSales,
          uberEatsSales: data.uberEatsSales,
          multipleSales: data.multipleSales,
        }));
        //this.watchTableDataSource.data = this.watches;
        //this.watchTableDataSource.paginator = this.watchTablePaginator;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        //alert(error);
        this.isLoading = false;
      }
    });*/
  }

  private loadCreamsSales(): void {
    /*this.gridData = this.authService.apiAuthCreamsSalesDashGet().pipe(
      map((data) => process(data, this.gridState))
    );*/

    this.authService.getMHSalesDash().pipe(take(1)).subscribe({
      next: (response: CreamsSalesDashVM) => {
        //alert("Test");()
        /*this.sales = response.map((data) => ({
          year: data.year,
          month: data.month,
          date: data.date,
          paymentMonth: data.paymentMonth,
          totalSales: data.totalSales,
          netSales: data.netSales,
          cardSales: data.cardSales,
          cashSales: data.cashSales,
          deliverySales: data.deliverySales,
          deliverooSales: data.deliverooSales,
          justEatSales: data.justEatSales,
          uberEatsSales: data.uberEatsSales,
          multipleSales: data.multipleSales,
        }));*/
        //this.watchTableDataSource.data = this.watches;
        //this.watchTableDataSource.paginator = this.watchTablePaginator;
        this.sales = response;
        //this.gridData = this.sales.salesByYear; //groupBy(this.sales, this.groups);
        this.gridData = process(this.sales.salesByYear, this.gridState);
        this.total = aggregateBy(this.gridData.data, this.aggregates);

        this.gridDataYearMonth = process(this.sales.salesByYearMonthVM, this.gridState);
        this.totalYearMonth = aggregateBy(this.gridDataYearMonth.data, this.aggregates);

        this.gridDataMonth = process(this.sales.salesByMonth, this.gridState);
        this.totalMonth = aggregateBy(this.gridDataMonth.data, this.aggregates);

        this.gridDataDayOfWeek = process(this.sales.salesByDayOfWeekVM, this.gridState);
        this.totalDayOfWeek = aggregateBy(this.gridDataDayOfWeek.data, this.aggregates);

        this.gridDataCurrentYear = process(this.sales.currentYear, this.gridState);

        this.gridDataCurrentMonth = process(this.sales.currentMonth, this.gridState);

        this.gridDataCurrentDay = process(this.sales.currentDate, this.gridState);
        //alert(this.total);
        //this.sales = this.sales.
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        //alert(error);
        this.isLoading = false;
      }
    });

  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.gridState = state;
    this.gridData = process(this.sales.salesByYear, this.gridState);
    this.total = aggregateBy(this.gridData.data, this.aggregates);
  }

  createWatch(): void {
    //let date = null;
  }

  updateWatch(args: AddEvent): void {
    var sid = args.dataItem.id;
  }

}
